import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: auto;
    // Alinhado com o resto da tela de Fazenda (farm-header e MainContainers,
    // em pages/nova-farm/styles.js) - esse componente só é usado ali. Soma real
    // das duas colunas (PrimaryContainer + gap + SecondContainer) = 1074px.
    max-width: 1074px;
    position: relative;
    
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const Wrapper = styled.div`
    width: 100%;
    max-width: 77rem;
    
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const CardNotification = styled.div`
    width: 100%;
    padding: 0.6rem;
    max-width: 77rem;
    
    display: flex;
    cursor: pointer;
    align-items: center;
    border-radius: 1rem;
    justify-content: space-between;
    background-color: rgba(255, 82, 82, 0.08);
`;

export const ImageAndNotification = styled.div`
    display: flex;
    align-items: center;
`;

export const ContainerImage = styled.div`
    width: 3rem;
    height: 3rem;
    
    display: flex;
    align-items: center;
    justify-content: center;

    > img {
        width: 2rem;
    }
`;

export const Notification = styled.div`
    max-width: 69rem;
    
    gap: 1rem;
    display: flex;
    margin-left: 1rem;
    position: relative;
    align-items: center;
    justify-content: center;

    p {
        cursor: pointer;

        font-size: 0.75rem;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;    
    }

    span { 
        padding: 0.25rem 0.5rem;
        
        display: flex;

        border-radius: 999px;
        background-color: white;
        text-align: center;
        text-transform: uppercase;

     
    }

    span p {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    @media (max-width: 1050px) {
        flex-direction: column;
    }
`;

export const ButtonLocalization = styled.button`
    all: unset;
    padding: 0.5rem;
    
    display: flex;
    align-items: center;
    
    border-radius: 10rem;
    background-color: #FFFFFF;
`;

export const PrevButton = styled.button`
    all: unset;
    
    top: 65%;
    left: 0.5rem;
    width: 3rem;
    height: 3rem;
    position: absolute;
    
    border: none;
    cursor: pointer;
    font-size: 1.5rem;
    border-radius: 50%;
    transform: translateY(-50%);

    @media (max-width: 1050px) {
        top: 58%;
    }
`;

export const NextButton = styled.button`
    all: unset;
    
    top: 42%;
    right: 0.5rem;
    width: 3rem;
    height: 3rem;
    position: absolute;
    
    border: none;
    cursor: pointer;
    font-size: 1.5rem;
    border-radius: 50%;
    transform: rotate(180deg);
`;
